export default __webpack_public_path__ + "static/aigul-a60cccbcc7b6d9b9601558bd62f8fd02.jpg";